import {CanActivateFn} from '@angular/router';
import {inject} from "@angular/core";
import {CommonService} from "../service/common.service";
import {NavController} from "@ionic/angular";
import {UserService} from "../service/user.service";
import {NavigationService} from "../service/navigation.service";

export const authGuard: CanActivateFn = (route, state) => {

  const data: any = route.data;

  const userService = inject(UserService);
  const navController = inject(NavController);
  const navigationService = inject(NavigationService);

  if (!userService.token) {

    navigationService.navigationAfterLogin = [state.url];
    console.log("authGuard-navigationAfterLogin", navigationService.navigationAfterLogin);
    if(data?.forceAuthDeepLing  && navigationService.fromDeeplinkUrl){
      navController.navigateForward(['/tabs/home']);
    }

    userService.showLoginModal();

    return false;
  } else {

    if (userService?.user?.mailConfirmed) {
      return true;
    } else {
      navController.navigateForward(['/mail-verified']);
      return false;
    }

  }

};
